//FU : src/pages/REG/REG300F5.jsx

import React from 'react';
import style from "./REG300F1.module.scss";
import styleCom from "./REGCOM.module.scss";
import toast from "components/Toast/Toast";
import Button from "components/Button/Button";
import InputUnitText from "components/InputText/InputUnitText";
import Table from "components/Table/Table";
import DatePicker from "components/DatePicker/DatePicker";
import {addDaysToDate, calc_eGFR, dateToYMD, getDaysBetween, ymdToDate} from './REGComUtil'; //
import Radio2 from "../../components/Radio/Radio2";
import RadioGroup from "../../components/Radio/RadioGroup";
import Checkbox from "../../components/Checkbox/Checkbox";


const RenderHtml = (props) => {


    const getFuIndex = (contentId) => {
        switch(contentId) {
            case "T8" : return 0; break;
            case "T9" : return 1; break;
            case "T10": return 2; break;
            default: return -1;
        }
    };
    const getFuDynamicCd = (key, index) =>
        `M${(parseInt(key.slice(1)) + index * 1000).toString().padStart(5, '0')}`;


    const fu001 = getFuDynamicCd('M06001', getFuIndex(props.contentId));
    const fu002 = getFuDynamicCd('M06002', getFuIndex(props.contentId));
    const fu003 = getFuDynamicCd('M06003', getFuIndex(props.contentId));
    const fu004 = getFuDynamicCd('M06004', getFuIndex(props.contentId));
    const fu005 = getFuDynamicCd('M06005', getFuIndex(props.contentId));
    const fu006 = getFuDynamicCd('M06006', getFuIndex(props.contentId));
    const fu007 = getFuDynamicCd('M06007', getFuIndex(props.contentId));
    const fu008 = getFuDynamicCd('M06008', getFuIndex(props.contentId));
    const fu009 = getFuDynamicCd('M06009', getFuIndex(props.contentId));
    const fu010 = getFuDynamicCd('M06010', getFuIndex(props.contentId));
    const fu011 = getFuDynamicCd('M06011', getFuIndex(props.contentId));
    const fu012 = getFuDynamicCd('M06012', getFuIndex(props.contentId));
    const fu013 = getFuDynamicCd('M06013', getFuIndex(props.contentId));
    const fu014 = getFuDynamicCd('M06014', getFuIndex(props.contentId));
    const fu015 = getFuDynamicCd('M06015', getFuIndex(props.contentId));
    const fu016 = getFuDynamicCd('M06016', getFuIndex(props.contentId));
    const fu017 = getFuDynamicCd('M06017', getFuIndex(props.contentId));
    const fu018 = getFuDynamicCd('M06018', getFuIndex(props.contentId));
    const fu019 = getFuDynamicCd('M06019', getFuIndex(props.contentId));
    const fu020 = getFuDynamicCd('M06020', getFuIndex(props.contentId));
    const fu021 = getFuDynamicCd('M06021', getFuIndex(props.contentId));
    const fu022 = getFuDynamicCd('M06022', getFuIndex(props.contentId));
    const fu023 = getFuDynamicCd('M06023', getFuIndex(props.contentId));
    const fu024 = getFuDynamicCd('M06024', getFuIndex(props.contentId));
    const fu025 = getFuDynamicCd('M06025', getFuIndex(props.contentId));
    const fu026 = getFuDynamicCd('M06026', getFuIndex(props.contentId));
    const fu027 = getFuDynamicCd('M06027', getFuIndex(props.contentId));
    const fu028 = getFuDynamicCd('M06028', getFuIndex(props.contentId));
    const fu029 = getFuDynamicCd('M06029', getFuIndex(props.contentId));
    const fu030 = getFuDynamicCd('M06030', getFuIndex(props.contentId));
    const fu031 = getFuDynamicCd('M06031', getFuIndex(props.contentId));
    const fu032 = getFuDynamicCd('M06032', getFuIndex(props.contentId));
    const fu033 = getFuDynamicCd('M06033', getFuIndex(props.contentId));
    const fu034 = getFuDynamicCd('M06034', getFuIndex(props.contentId));
    const fu035 = getFuDynamicCd('M06035', getFuIndex(props.contentId));
    const fu036 = getFuDynamicCd('M06036', getFuIndex(props.contentId));
    const fu037 = getFuDynamicCd('M06037', getFuIndex(props.contentId));
    const fu038 = getFuDynamicCd('M06038', getFuIndex(props.contentId));
    const fu039 = getFuDynamicCd('M06039', getFuIndex(props.contentId));
    const fu040 = getFuDynamicCd('M06040', getFuIndex(props.contentId));
    const fu041 = getFuDynamicCd('M06041', getFuIndex(props.contentId));
    const fu042 = getFuDynamicCd('M06042', getFuIndex(props.contentId));
    const fu043 = getFuDynamicCd('M06043', getFuIndex(props.contentId));
    const fu044 = getFuDynamicCd('M06044', getFuIndex(props.contentId));
    const fu045 = getFuDynamicCd('M06045', getFuIndex(props.contentId));
    const fu046 = getFuDynamicCd('M06046', getFuIndex(props.contentId));
    const fu047 = getFuDynamicCd('M06047', getFuIndex(props.contentId));
    const fu048 = getFuDynamicCd('M06048', getFuIndex(props.contentId));
    const fu049 = getFuDynamicCd('M06049', getFuIndex(props.contentId));
    const fu050 = getFuDynamicCd('M06050', getFuIndex(props.contentId));
    const fu051 = getFuDynamicCd('M06051', getFuIndex(props.contentId));
    const fu052 = getFuDynamicCd('M06052', getFuIndex(props.contentId));
    const fu053 = getFuDynamicCd('M06053', getFuIndex(props.contentId));
    const fu054 = getFuDynamicCd('M06054', getFuIndex(props.contentId));
    const fu055 = getFuDynamicCd('M06055', getFuIndex(props.contentId));
    const fu056 = getFuDynamicCd('M06056', getFuIndex(props.contentId));
    const fu057 = getFuDynamicCd('M06057', getFuIndex(props.contentId));
    const fu058 = getFuDynamicCd('M06058', getFuIndex(props.contentId));
    const fu059 = getFuDynamicCd('M06059', getFuIndex(props.contentId));
    const fu060 = getFuDynamicCd('M06060', getFuIndex(props.contentId));
    const fu061 = getFuDynamicCd('M06061', getFuIndex(props.contentId));
    const fu062 = getFuDynamicCd('M06062', getFuIndex(props.contentId));


    let fuHtml=<></>;

    const radioOptions = [
         {mapCd: fu003, value: "1", label: "Clinical"}, {mapCd: fu003, value: "2", label: "Telephone"}
        ,{mapCd: fu004, value: "1", label: "Patient died"}, {mapCd: fu004, value: "2", label: "lost to FU"}
        ,{mapCd: fu004, value: "3", label: "Other"}
        ,{mapCd: fu006,value: "1", label: "Yes"},{mapCd: fu006,value: "2", label: "No"}
        ,{mapCd: fu008, value: "1", label: "Cardiac death"}, {mapCd: fu008, value: "2", label: "Non- cardiac death"}
        ,{mapCd: fu010, value: "1", label: "Target-Vessel (TV)-MI"}, {mapCd: fu010, value: "2", label: "Non-Target-Vessel (non-TV)-MI"}
        ,{mapCd: fu016, value: "1", label: "Definite (CAG로 확인, 또는 48시간내 새로운 안정시 흉통, EKG상 심근허혈 의심, Cardiac enzyme↑)"}
        ,{mapCd: fu016, value: "2", label: "Probable (첫 30일 이내 사유 불분명한 사망, MI)"}
        ,{mapCd: fu016, value: "3", label: "Possible (30일 이후 사유 불분명한 사망)"}
        ,{mapCd: fu021,value: "1", label: "Yes"},{mapCd: fu021,value: "2", label: "No"},{mapCd: fu021,value: "3", label: "Unknown"}
        ,{mapCd: fu022,value: "1", label: "Yes"},{mapCd: fu022,value: "2", label: "No"},{mapCd: fu022,value: "3", label: "Unknown"}
        ,{mapCd: fu023,value: "1", label: "Yes"},{mapCd: fu023,value: "2", label: "No"},{mapCd: fu023,value: "3", label: "Unknown"}
        ,{mapCd: fu031,value: "1", label: "Yes"},{mapCd: fu031,value: "2", label: "No"},{mapCd: fu031,value: "3", label: "Unknown"}
        ,{mapCd: fu032,value: "1", label: "Yes"},{mapCd: fu032,value: "2", label: "No"},{mapCd: fu032,value: "3", label: "Unknown"}
        ,{mapCd: fu033,value: "1", label: "Warfarin (Coumadin)"},{mapCd: fu033,value: "2", label: "Dabigatran"}
        ,{mapCd: fu033,value: "3", label: "Apixaban"},{mapCd: fu033,value: "4", label: "Rivaroxaban"}
        ,{mapCd: fu033,value: "5", label: "Edoxaban"},{mapCd: fu033,value: "6", label: "Other"}
        ,{mapCd: fu037,value: "1", label: "Yes"},{mapCd: fu037,value: "2", label: "No"},{mapCd: fu037,value: "3", label: "Unknown"}
        ,{mapCd: fu038,value: "1", label: "Yes"},{mapCd: fu038,value: "2", label: "No"},{mapCd: fu038,value: "3", label: "Unknown"}
        ,{mapCd: fu039,value: "1", label: "Yes"},{mapCd: fu039,value: "2", label: "No"},{mapCd: fu039,value: "3", label: "Unknown"}
        ,{mapCd: fu040,value: "1", label: "Yes"},{mapCd: fu040,value: "2", label: "No"},{mapCd: fu040,value: "3", label: "Unknown"}
        ,{mapCd: fu041,value: "1", label: "Yes"},{mapCd: fu041,value: "2", label: "No"},{mapCd: fu041,value: "3", label: "Unknown"}
        ,{mapCd: fu042,value: "1", label: "Yes"},{mapCd: fu042,value: "2", label: "No"},{mapCd: fu042,value: "3", label: "Unknown"}
        ,{mapCd: fu043,value: "1", label: "Yes"},{mapCd: fu043,value: "2", label: "No"},{mapCd: fu043,value: "3", label: "Unknown"}
        ,{mapCd: fu044,value: "1", label: "Yes"},{mapCd: fu044,value: "2", label: "No"},{mapCd: fu044,value: "3", label: "Unknown"}
        ,{mapCd: fu045,value: "1", label: "Yes"},{mapCd: fu045,value: "2", label: "No"},{mapCd: fu045,value: "3", label: "Unknown"}
        ,{mapCd: fu046,value: "1", label: "Yes"},{mapCd: fu046,value: "2", label: "No"},{mapCd: fu046,value: "3", label: "Unknown"}
        ,{mapCd: fu047,value: "1", label: "Yes"},{mapCd: fu047,value: "2", label: "No"},{mapCd: fu047,value: "3", label: "Unknown"}
        ,{mapCd: fu048,value: "1", label: "Yes"},{mapCd: fu048,value: "2", label: "No"},{mapCd: fu048,value: "3", label: "Unknown"}
        ,{mapCd: fu049,value: "1", label: "Yes"},{mapCd: fu049,value: "2", label: "No"},{mapCd: fu049,value: "3", label: "Unknown"}

    ];

    const activeFlagObj = props.activeFlagObj;

    const btnAllObj = [
         {mapCd: fu019, tarId:fu021, tarVal:"2"},{mapCd: fu019, tarId:fu022, tarVal:"2"}
        ,{mapCd: fu019, tarId:fu031, tarVal:"2"},{mapCd: fu019, tarId:fu032, tarVal:"2"}
        ,{mapCd: fu020, tarId:fu021, tarVal:"3"},{mapCd: fu020, tarId:fu022, tarVal:"3"}
        ,{mapCd: fu020, tarId:fu031, tarVal:"3"},{mapCd: fu020, tarId:fu032, tarVal:"3"}
        ,{mapCd: fu035, tarId:fu036, tarVal:"2"},{mapCd: fu035, tarId:fu037, tarVal:"2"}
        ,{mapCd: fu035, tarId:fu038, tarVal:"2"},{mapCd: fu035, tarId:fu039, tarVal:"2"}
        ,{mapCd: fu035, tarId:fu040, tarVal:"2"},{mapCd: fu035, tarId:fu041, tarVal:"2"}
        ,{mapCd: fu035, tarId:fu042, tarVal:"2"},{mapCd: fu035, tarId:fu043, tarVal:"2"}
        ,{mapCd: fu035, tarId:fu044, tarVal:"2"},{mapCd: fu035, tarId:fu045, tarVal:"2"}
        ,{mapCd: fu035, tarId:fu046, tarVal:"2"},{mapCd: fu035, tarId:fu047, tarVal:"2"}
        ,{mapCd: fu035, tarId:fu048, tarVal:"2"},{mapCd: fu035, tarId:fu049, tarVal:"2"}
        ,{mapCd: fu036, tarId:fu036, tarVal:"3"},{mapCd: fu036, tarId:fu037, tarVal:"3"}
        ,{mapCd: fu036, tarId:fu038, tarVal:"3"},{mapCd: fu036, tarId:fu039, tarVal:"3"}
        ,{mapCd: fu036, tarId:fu040, tarVal:"3"},{mapCd: fu036, tarId:fu041, tarVal:"3"}
        ,{mapCd: fu036, tarId:fu042, tarVal:"3"},{mapCd: fu036, tarId:fu043, tarVal:"3"}
        ,{mapCd: fu036, tarId:fu044, tarVal:"3"},{mapCd: fu036, tarId:fu045, tarVal:"3"}
        ,{mapCd: fu036, tarId:fu046, tarVal:"3"},{mapCd: fu036, tarId:fu047, tarVal:"3"}
        ,{mapCd: fu036, tarId:fu048, tarVal:"3"},{mapCd: fu036, tarId:fu049, tarVal:"3"}
        ,{mapCd: fu050, tarId:fu051, tarVal:""},{mapCd: fu050, tarId:fu052, tarVal:"ND"}
        ,{mapCd: fu050, tarId:fu053, tarVal:"ND"},{mapCd: fu050, tarId:fu054, tarVal:"ND"}
        ,{mapCd: fu050, tarId:fu055, tarVal:"ND"},{mapCd: fu050, tarId:fu056, tarVal:"ND"}
        ,{mapCd: fu050, tarId:fu057, tarVal:"ND"},{mapCd: fu050, tarId:fu058, tarVal:"ND"}
        ,{mapCd: fu050, tarId:fu059, tarVal:"ND"},{mapCd: fu050, tarId:fu060, tarVal:"ND"}
        ,{mapCd: fu050, tarId:fu061, tarVal:"ND"},{mapCd: fu050, tarId:fu062, tarVal:"ND"}
    ];


    function getOptionList(cdValue) {
        return radioOptions.filter(option => option.mapCd === cdValue);
    }

    const activeEvent = (mapCd, value="") =>{
        /* activeEvent :
         * - 이벤트 발생시 코드와 값을 기준으로 컴포넌트 활성화/비활성화를 제어하는 상태값 변경
         * - 데이터가 존재하는 activeFlag 필드 값을 변경하여 제어( readOlny 같은 옵션에서 값을 참조하는방식)
         */
        const matchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='matched' && item.chkVal === value
        );
        const notMatchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='notMatched'
        );
        if(matchedObj.length > 0){
            matchedObj.forEach(item => {
                if(matchedObj.length > 0 && item.chkVal === value){
                    props.setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                    props.setDtlValue(item.tarId, item.tarVal, 'itmRslt');
                }
            });
        }else if(notMatchedObj.length > 0){
            notMatchedObj.forEach(item => {
                props.setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                props.setDtlValue(item.tarId, item.tarVal, 'itmRslt');
            });
        }

    }

    const btnAllEvent = (mapCd) => {
        /* 일괄 선택 처리 */
        const allObj = btnAllObj.filter(item => item.mapCd === mapCd);
        if (allObj.length > 0) {
            allObj.forEach(item => {
                props.setDtlValue(item.tarId, item.tarVal);
                activeEvent(item.tarId, item.tarVal);
            });
        }
    };

    const copyTargetObj = (btnId, refId, tarId) => {
        const result = [];
        const refPrefix = refId.charAt(0);
        const tarPrefix = tarId.charAt(0);
        const refNum = parseInt(refId.slice(1), 10);
        const tarNum = parseInt(tarId.slice(1), 10);

        for (let i = 0; i < 29; i++) {
            result.push({
                btnId: btnId,
                refId: refPrefix + String(refNum + i).padStart(5, '0'),
                tarId: tarPrefix + String(tarNum + i).padStart(5, '0')
            });
        }

        return result;
    };

    const btnCopyMedication = (mapCd) => {
        /* 요청사항 반영 2025.06.02
        *  퇴원시 입력한 값(Discharge)을 1M FU 추적관찰시 불러오고
        *  1M FU 값을 6M FU에
        *  6M FU 값을 12M FU에 세팅
         */

        let targetObj = [];
        let copyId = "";

        switch(getFuIndex(props.contentId)) {
            case 0:  copyId = "M05025";  break;
            case 1:  copyId = "M06021";  break;
            case 2:  copyId = "M07021";  break;
            default:  copyId = "";  break;
        }

        switch(mapCd) {
            case fu018:
                targetObj = copyTargetObj(mapCd,copyId,fu021);
                break;
            default:

        }
        if (targetObj.length > 0) {
            targetObj.forEach(item => {
                props.setDtlValue(item.tarId, props.getDtlValue(item.refId));
                activeEvent(item.tarId, props.getDtlValue(item.refId));
            });
        }
    };


    /* Event ****************************************************************************** */

    const compValue = (mpaCd) => {
        return props.getDtlValue(mpaCd);
    }

    const compChange = (mapCd, value) => {
        props.setDtlValue(mapCd, value);
        activeEvent(mapCd, value);

        if(mapCd===fu002){
        /* 추적관찰- Follow Up date(Has the Subject completed this visit)
        * 기준일은 PCI 시행일(Baseline)
        * 1 Month Follow Up date는 PCI 시행일(Baseline) ~30 ± 21d
        * 6 Month Follow Up date는 PCI 시행일(Baseline) ~180 ± 90d
        * 12 Month Follow Up date는 PCI 시행일(Baseline) ~360 ± 90d
        * *************************************************************** */

            let chkBaseDay = 0;
            let chkLimitDay = 0;

            switch(getFuIndex(props.contentId)) {
                case 0: chkBaseDay=30;  break;
                case 1: chkBaseDay=180;  break;
                case 2: chkBaseDay=360;  break;
                default: chkBaseDay=-1;   break;
            }
            switch(getFuIndex(props.contentId)) {
                case 0: chkLimitDay=21;  break;
                case 1: chkLimitDay=90;  break;
                case 2: chkLimitDay=90;  break;
                default: chkLimitDay=-1; break;
            }

            const baseYmd = addDaysToDate(props.getMstValue('pciDt'), chkBaseDay);  //PCI 시행일기준

            if(baseYmd===null){
                toast({type: 'info', message: "PCI 시행일을 확인하여 주십시오.", opt: {position: "top-center"}});
                //props.setDtlValue(fu002, '');
                return;
            }
            //1M  : 30 ± 21, 6M  : 180 ± 90, 12M : 360 ± 90
            let calcDay = getDaysBetween(baseYmd, value);
            if( typeof calcDay === "number"
                && (    ( calcDay>= 0 && (calcDay)     > chkLimitDay)
                     || ( calcDay< 0 && (calcDay*(-1)) > chkLimitDay)
                   )
              ){
                toast({type: 'info', message: "날짜 입력범위(±"+chkLimitDay+")를 초과하였습니다.", opt: {position: "top-center"}});
                //props.setDtlValue(fu002, '');
            }
        }

        /* eGFR계산 ******************************* */
        switch (mapCd) {
            case fu055:
                props.setDtlValue(fu056,calc_eGFR(value, props.getMstValue('age'), props.getMstValue('sex')))
            break;

            default:
            break;

        }


    }

    /* ****************************************************************************** Event */

    const insertSpace = (index) => {
        return new Array(index).fill("\u00A0").map((space, idx) => (
            <span key={idx}>{space}</span>
        ));
    };


    fuHtml =
        <>
            <div className={styleCom.title_wrap}>
                <h3>추적관찰</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={2} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>Has the Subject completed this visit</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <Radio2 label="Yes" value="1" selectedValue={props.getDtlValue(fu001)}
                                            onChange={(val) => compChange(fu001, val)}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    If Yes,
                                    <div className={style.cellFlex}>
                                        <DatePicker selDate={ymdToDate(props.getDtlValue(fu002))} dateFormat={'yyyy-MM-dd'}
                                                    isDisabled={props.getDtlValue(fu002, 'activeFlag')}
                                                    onChange={(date) => compChange(fu002, dateToYMD(date))}/>
                                        <RadioGroup options={getOptionList(fu003)}
                                                    selectedValue={compValue(fu003)}
                                                    onChange={(val) => compChange(fu003, val)}
                                                    disabled={props.getDtlValue(fu003, 'activeFlag')}/>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Radio2 label="No" value="2" selectedValue={props.getDtlValue(fu001)}
                                            onChange={(val) => compChange(fu001, val)}/>
                                    If No Reason :
                                    <div className={style.cellFlex}>
                                        <RadioGroup options={getOptionList(fu004)}
                                                    selectedValue={props.getDtlValue(fu004)}
                                                    onChange={(val) => compChange(fu004, val)}
                                                    disabled={props.getDtlValue(fu004, 'activeFlag')}/>
                                        <InputUnitText type={"text"} value={props.getDtlValue(fu005)} unit={""}
                                                       onChange={(value) => props.setDtlValue(fu005, value)}
                                                       maxLength={30} width={"300px"}
                                                       readOnly={props.getDtlValue(fu005, 'activeFlag')}/>

                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>Clinical event</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup options={getOptionList(fu006)}
                                                selectedValue={props.getDtlValue(fu006)}
                                                onChange={(val) => compChange(fu006, val)}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    If Yes,
                                    <Checkbox label={"Death"}
                                              onChange={(e) => compChange(fu007, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(fu007) === '1'}
                                              isDisabled={props.getDtlValue(fu007, 'activeFlag')}/>
                                    <RadioGroup options={getOptionList(fu008)} marginLeft={"10px"}
                                                selectedValue={props.getDtlValue(fu008)}
                                                onChange={(val) => props.setDtlValue(fu008, val)}
                                                disabled={props.getDtlValue(fu008, 'activeFlag')}/>
                                    <Checkbox label={"MI"} marginTop={'3px'}
                                              onChange={(e) => compChange(fu009, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(fu009) === '1'}
                                              isDisabled={props.getDtlValue(fu009, 'activeFlag')}/>
                                    <RadioGroup options={getOptionList(fu010)}  marginLeft={"10px"}
                                                selectedValue={props.getDtlValue(fu010)}
                                                onChange={(val) => props.setDtlValue(fu010, val)}
                                                disabled={props.getDtlValue(fu010, 'activeFlag')}/>

                                    <Checkbox label={"Target lesion revascularization(TLR)"} marginTop={'3px'}
                                              onChange={(e) => props.setDtlValue(fu011, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(fu011) === '1'}
                                              isDisabled={props.getDtlValue(fu011, 'activeFlag')}/>
                                    <Checkbox label={"Target vessel revascularization(TVR)"} marginTop={'3px'}
                                              onChange={(e) => props.setDtlValue(fu012, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(fu012) === '1'}
                                              isDisabled={props.getDtlValue(fu012, 'activeFlag')}/>
                                    <Checkbox label={"CABG"} marginTop={'3px'}
                                              onChange={(e) => props.setDtlValue(fu013, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(fu013) === '1'}
                                              isDisabled={props.getDtlValue(fu013, 'activeFlag')}/>
                                    <Checkbox marginTop={'3px'}
                                        label={"Cerebrovascular accident (CVA) (Ischemic (허혈성) or Hemorrhagic (출혈성) stroke 포함)"}
                                        onChange={(e) => props.setDtlValue(fu014, e.target.checked ? '1' : '0')}
                                        checked={props.getDtlValue(fu014) === '1'}
                                        isDisabled={props.getDtlValue(fu014, 'activeFlag')}/>
                                    <Checkbox label={"Stent thrombosis(ST)"} marginTop={'3px'}
                                              onChange={(e) => compChange(fu015, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(fu015) === '1'} marginBottom={"3px"}
                                              isDisabled={props.getDtlValue(fu015, 'activeFlag')}/>
                                    <RadioGroup marginLeft={"10px"}
                                        options={getOptionList(fu016)} colCnt={1}
                                        selectedValue={compValue(fu016)}
                                        onChange={(val) => compChange(fu016, val)}
                                        disabled={props.getDtlValue(fu016, 'activeFlag')}/>
                                    <Checkbox marginTop={'3px'}
                                        label={"TIMI major bleeding (BARC Type 3이상: intracranial hemorrhage or Hb↓≥ 5mg/dL or Hct↓≥ 15% 중 하나를 만족하는 경우)"}
                                        onChange={(e) => props.setDtlValue(fu017, e.target.checked ? '1' : '0')}
                                        checked={props.getDtlValue(fu017) === '1'}
                                        isDisabled={props.getDtlValue(fu017, 'activeFlag')}/>
                                </td>
                            </tr>

                            </tbody>
                        </table>
                    </div>

                </Table>
            </div>
            <div className={styleCom.title_wrap}>
                <div style={{marginTop:"10px"}}>
                    <Button variant="Primary" addStyle={{width: "280px", height: "40px"}}
                            onClick={() => btnCopyMedication(fu018)}>Medication Copy from previous visit</Button>

                </div>
                <div className={styleCom.ailgnSpaceBetween}>
                    <span>
                        <h3>Anti-platelet and Anti-coagulant</h3>
                    </span>
                    <span>
                        <div style={{display: "flex"}}>
                            <Button variant="Primary" addStyle={{width: "70px", height: "40px"}}
                                    onClick={() => btnAllEvent(fu019)}>ALL NO</Button>
                            {insertSpace(2)}
                            <Button variant="Secondary" addStyle={{width: "100px", height: "40px"}}
                                    onClick={() => btnAllEvent(fu020)}>All Unknown</Button>
                        </div>
                    </span>
                </div>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={4} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>Aspirin</div>
                    <div>
                        <RadioGroup options={getOptionList(fu021)} selectedValue={compValue(fu021)}
                                    onChange={(val) => props.setDtlValue(fu021, val)}/>
                    </div>
                    <div>P2Y12 RI</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                <RadioGroup options={getOptionList(fu022)}
                                                selectedValue={props.getDtlValue(fu022)}
                                                onChange={(val) => compChange(fu022, val)}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>If Yes,</p>
                                    <Radio2 label="Clopidogrel" value="1"
                                            disabled={props.getDtlValue(fu023, 'activeFlag')}
                                            selectedValue={props.getDtlValue(fu023)}
                                            onChange={(val) => compChange(fu023, val)}/>
                                    <div className={style.cellFlex}>
                                        <Radio2 label="Prasugrel" value="2"
                                                disabled={props.getDtlValue(fu023, 'activeFlag')}
                                                selectedValue={props.getDtlValue(fu023)}
                                                onChange={(val) => compChange(fu023, val)}/>
                                        (<Checkbox label={"10mg qd"}
                                                   onChange={(e) => props.setDtlValue(fu024, e.target.checked ? '1' : '0')}
                                                   checked={props.getDtlValue(fu024) === '1'}
                                                   isDisabled={props.getDtlValue(fu024, 'activeFlag')}/>
                                        <Checkbox label={"5mg qd"}
                                                  onChange={(e) => props.setDtlValue(fu025, e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue(fu025) === '1'}
                                                  isDisabled={props.getDtlValue(fu025, 'activeFlag')}/>)
                                    </div>
                                    <div className={style.cellFlex}>
                                        <Radio2 label="Ticagrelor" value="3"
                                                disabled={props.getDtlValue(fu023, 'activeFlag')}
                                                selectedValue={props.getDtlValue(fu023)}
                                                onChange={(val) => compChange(fu023, val)}/>
                                        (<Checkbox label={"90mg qd"}
                                                   onChange={(e) => props.setDtlValue(fu026, e.target.checked ? '1' : '0')}
                                                   checked={props.getDtlValue(fu026) === '1'}
                                                   isDisabled={props.getDtlValue(fu026, 'activeFlag')}/>
                                        <Checkbox label={"90mg bid"}
                                                  onChange={(e) => props.setDtlValue(fu027, e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue(fu027) === '1'}
                                                  isDisabled={props.getDtlValue(fu027, 'activeFlag')}/>
                                        <Checkbox label={"60mg bid"}
                                                  onChange={(e) => props.setDtlValue(fu028, e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue(fu028) === '1'}
                                                  isDisabled={props.getDtlValue(fu028, 'activeFlag')}/>
                                        <Checkbox label={"45mg bid"}
                                                  onChange={(e) => props.setDtlValue(fu029, e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue(fu029) === '1'}
                                                  isDisabled={props.getDtlValue(fu029, 'activeFlag')}/>)
                                    </div>
                                    <div className={style.cellFlex}>
                                        <Radio2 label="Other" value="4" selectedValue={props.getDtlValue(fu023)}
                                                onChange={(val) => compChange(fu023, val)}
                                                disabled={props.getDtlValue(fu023, 'activeFlag')}/>
                                        <InputUnitText type={"text"} value={props.getDtlValue(fu030)} unit={""}
                                                       onChange={(value) => props.setDtlValue(fu030, value)}
                                                       maxLength={30} width={"300px"}
                                                       readOnly={props.getDtlValue(fu030, 'activeFlag')}/>
                                    </div>


                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>Cilostazol</div>
                    <div>
                        <RadioGroup options={getOptionList(fu031)}
                                    selectedValue={props.getDtlValue(fu031)}
                                    onChange={(val) => props.setDtlValue(fu031, val)}/>
                    </div>
                    <div>Anti-coagulant</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup options={getOptionList(fu032)}
                                                selectedValue={compValue(fu032)}
                                                onChange={(val) => compChange(fu032, val)}/>

                                </td>
                            </tr>
                            <tr>
                                <td>
                                    If Yes,
                                    <div className={style.cellFlex}>
                                        <RadioGroup  options={getOptionList(fu033)} colCnt={3}
                                                     selectedValue={compValue(fu033)}
                                                     onChange={(val) => compChange(fu033, val)}
                                                     disabled={props.getDtlValue(fu033, 'activeFlag')}/>
                                        <InputUnitText type={"text"} marginTop={"32px"}
                                                       value={props.getDtlValue(fu034)} unit={""}
                                                       onChange={(value) => props.setDtlValue(fu034, value)}
                                                       maxLength={30} width={"300px"}
                                                       readOnly={props.getDtlValue(fu034, 'activeFlag')}/>
                                    </div>

                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </Table>
            </div>

            <div className={styleCom.title_wrap} style={{marginTop: "10px"}}>
                <div className={styleCom.ailgnSpaceBetween}>
                    <span>
                        <h3>Concomitant Medication</h3>
                    </span>
                    <span>
                        <div style={{display: "flex"}}>
                            <Button variant="Primary" addStyle={{width: "70px", height: "40px"}}
                                    onClick={() => btnAllEvent(fu035)}>ALL NO</Button>
                            {insertSpace(2)}
                            <Button variant="Secondary" addStyle={{width: "100px", height: "40px"}}
                                    onClick={() => btnAllEvent(fu036)}>All Unknown</Button>
                        </div>
                    </span>
                </div>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='defualt' rowCnt={9} colSize={['25%', '25%', '25%', '25%']} rowSize={'56px'}>
                    <div>Medication</div>
                    <div className={style.titleCell}>Ongoing</div>
                    <div>Medication</div>
                    <div className={style.titleCell}>Ongoing</div>
                    <div>Beta Blocker</div>
                    <div>
                        <RadioGroup options={getOptionList(fu037)}
                                    selectedValue={props.getDtlValue(fu037)}
                                    onChange={(val) => props.setDtlValue(fu037, val)}/>
                    </div>
                    <div>CCB: Dihydropyridine</div>
                    <div>
                        <RadioGroup options={getOptionList(fu038)}
                                    selectedValue={props.getDtlValue(fu038)}
                                    onChange={(val) => props.setDtlValue(fu038, val)}/>
                    </div>
                    <div>ARB</div>
                    <div>
                        <RadioGroup options={getOptionList(fu039)}
                                    selectedValue={props.getDtlValue(fu039)}
                                    onChange={(val) => props.setDtlValue(fu039, val)}/>
                    </div>
                    <div>
                        CCB:Non-dihydropyridine
                        <br/>(Verapamil/ Diltiazem)
                    </div>
                    <div>
                        <RadioGroup options={getOptionList(fu040)}
                                    selectedValue={props.getDtlValue(fu040)}
                                    onChange={(val) => props.setDtlValue(fu040, val)}/>
                    </div>
                    <div>ACE inhibitor</div>
                    <div className={'col_merge'}>
                        <RadioGroup options={getOptionList(fu041)}
                                    selectedValue={props.getDtlValue(fu041)}
                                    onChange={(val) => props.setDtlValue(fu041, val)}/>
                    </div>
                    <div>Statin</div>
                    <div>
                        <RadioGroup options={getOptionList(fu042)}
                                    selectedValue={props.getDtlValue(fu042)}
                                    onChange={(val) => props.setDtlValue(fu042, val)}/>
                    </div>
                    <div>Ezetimibe</div>
                    <div>
                        <RadioGroup options={getOptionList(fu043)}
                                    selectedValue={props.getDtlValue(fu043)}
                                    onChange={(val) => props.setDtlValue(fu043, val)}/>
                    </div>
                    <div>Fibrate</div>
                    <div className={"col_merge"}>
                        <RadioGroup options={getOptionList(fu044)}
                                    selectedValue={props.getDtlValue(fu044)}
                                    onChange={(val) => props.setDtlValue(fu044, val)}/>
                    </div>
                    <div>Nitroglycerin</div>
                    <div>
                        <RadioGroup options={getOptionList(fu045)}
                                    selectedValue={props.getDtlValue(fu045)}
                                    onChange={(val) => props.setDtlValue(fu045, val)}/>
                    </div>
                    <div>Nicorandil</div>
                    <div>
                        <RadioGroup options={getOptionList(fu046)}
                                    selectedValue={props.getDtlValue(fu046)}
                                    onChange={(val) => props.setDtlValue(fu046, val)}/>
                    </div>
                    <div>Trimetazidine</div>
                    <div>
                        <RadioGroup options={getOptionList(fu047)}
                                    selectedValue={props.getDtlValue(fu047)}
                                    onChange={(val) => props.setDtlValue(fu047, val)}/>
                    </div>
                    <div>Diuretics</div>
                    <div>
                        <RadioGroup options={getOptionList(fu048)}
                                    selectedValue={props.getDtlValue(fu048)}
                                    onChange={(val) => props.setDtlValue(fu048, val)}/>
                    </div>
                    <div>PPI or P-cab</div>
                    <div className={'col_merge'}>
                        <RadioGroup options={getOptionList(fu049)}
                                    selectedValue={props.getDtlValue(fu049)}
                                    onChange={(val) => props.setDtlValue(fu049, val)}/>
                    </div>
                </Table>
            </div>
            <div className={styleCom.title_wrap} style={{marginTop: "10px"}}>
                <div className={styleCom.ailgnSpaceBetween}>
                    <span>
                        <div style={{display: "flex"}}>
                            <h3>Lab data (시행한 값이 있을 경우 수집)</h3>
                        </div>
                    </span>
                    <span>
                        <div style={{display: "flex"}}>
                        <Button variant="Primary" addStyle={{width: "70px", height: "40px"}}
                                onClick={() => btnAllEvent(fu050)}>ALL None</Button>

                        </div>
                    </span>
                </div>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={12} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>Lab Date</div>
                    <div>
                        <DatePicker selDate={ymdToDate(props.getDtlValue(fu051))}
                                    dateFormat={'yyyy-MM-dd'}
                                    onChange={(date) => props.setDtlValue(fu051, dateToYMD(date))}/>
                    </div>
                    <div>Hb(g/dL)</div>
                    <div>
                        <InputUnitText value={props.getDtlValue(fu052)}
                                       onChange={(value) => props.setDtlValue(fu052, value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue(fu052, "ND")}>
                            ND
                        </Button>
                    </div>
                    <div>Hct(%)</div>
                    <div>
                        <InputUnitText value={props.getDtlValue(fu053)}
                                       onChange={(value) => props.setDtlValue(fu053, value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue(fu053, "ND")}>
                            ND
                        </Button>
                    </div>
                    <div>Platelet(x10³/mm³)</div>
                    <div>
                        <InputUnitText value={props.getDtlValue(fu054)}
                                       onChange={(value) => props.setDtlValue(fu054, value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue(fu054, "ND")}>
                            ND
                        </Button>
                    </div>
                    <div>Creatinine(mg/dL)</div>
                    <div>
                        <InputUnitText value={props.getDtlValue(fu055)}
                                       onChange={(value) => compChange(fu055, value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue(fu055, "ND")}>
                            ND
                        </Button>
                    </div>
                    <div>eGFR(mL/min/1.73m2)</div>
                    <div>
                        <InputUnitText value={props.getDtlValue(fu056)}
                                       onChange={(value) => props.setDtlValue(fu056, value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue(fu056, "ND")}>
                            ND
                        </Button>
                    </div>
                    <div>Total cholesterol(mg/dL)</div>
                    <div>
                        <InputUnitText value={props.getDtlValue(fu057)}
                                       onChange={(value) => props.setDtlValue(fu057, value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue(fu057, "ND")}>
                            ND
                        </Button>
                    </div>
                    <div>TG(mg/dL)</div>
                    <div>
                        <InputUnitText value={props.getDtlValue(fu058)}
                                       onChange={(value) => props.setDtlValue(fu058, value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue(fu058, "ND")}>
                            ND
                        </Button>
                    </div>
                    <div>HDL(mg/dL)</div>
                    <div>
                        <InputUnitText value={props.getDtlValue(fu059)}
                                       onChange={(value) => props.setDtlValue(fu059, value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue(fu059, "ND")}>
                            ND
                        </Button>
                    </div>
                    <div>LDL(mg/dL)</div>
                    <div>
                        <InputUnitText value={props.getDtlValue(fu060)}
                                       onChange={(value) => props.setDtlValue(fu060, value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue(fu060, "ND")}>
                            ND
                        </Button>
                    </div>
                    <div>Platelet Reactivity Units(PRU)</div>
                    <div>
                        <InputUnitText value={props.getDtlValue(fu061)}
                                       onChange={(value) => props.setDtlValue(fu061, value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue(fu061, "ND")}>
                            ND
                        </Button>
                    </div>
                    <div>HbA1C(%)</div>
                    <div>
                        <InputUnitText value={props.getDtlValue(fu062)}
                                       onChange={(value) => props.setDtlValue(fu062, value)}/>
                        <Button variant="Outline" addStyle={{width: "54px", height: "40px"}}
                                onClick={(e) => props.setDtlValue(fu062, "ND")}>
                            ND
                        </Button>
                    </div>


                </Table>
            </div>

        </>
    ;


    let renderHtml =
        <></>
    ;

    if (props.contentId === "T8" || props.contentId === "T9" || props.contentId === "T10") {
        renderHtml = fuHtml;

    } else{
        renderHtml = <h3>페이지를 확인할 수 없습니다. 서비스를 다시시작하여 주십시오.</h3>;
    }
    
    return (
        <>
            {renderHtml}
        </>
    );

};

export default RenderHtml;

